import React from "react";
import { Star } from "lucide-react";

const STARS = [1, 2, 3, 4, 5];

const Glyph = ({ on, size }) => (
  <Star
    aria-hidden="true"
    style={{ width: size, height: size }}
    className={on ? "fill-accent text-accent" : "fill-transparent text-muted-foreground/45"}
  />
);

/** Read-only ratings are one labelled image; the input variant is five buttons. */
export const StarRating = ({ value = 0, size = 16, interactive = false, onChange }) => {
  const val = Number(value) || 0;
  if (!interactive) {
    return (
      <span className="inline-flex items-center gap-0.5" role="img" aria-label={`${val.toFixed(1)} / 5`} data-testid="star-rating">
        {STARS.map((i) => <Glyph key={i} on={i <= Math.round(val)} size={size} />)}
      </span>
    );
  }
  return (
    <div className="flex items-center gap-1" role="radiogroup" aria-label="Rating" data-testid="star-rating">
      {STARS.map((i) => (
        <button
          key={i} type="button" role="radio" aria-checked={i === val} aria-label={`${i} / 5`}
          onClick={() => onChange?.(i)}
          className="p-1 -m-1 rounded-sm"
          data-testid={`star-${i}-input`}
        >
          <Glyph on={i <= val} size={size} />
        </button>
      ))}
    </div>
  );
};
